<template>
  <v-flex lg12 md12 sm12 xs12 :class="['pa-2']" v-if="video">
    <v-card :class="['full-height']">
      <v-card-title :class="['py-0', 'pr-2']">
        <div v-html="$lang.featuredVideo(video.title)" />
        <v-spacer />
        <v-btn flat icon dark :class="['mr-0']" to="/videos" :title="$lang.allVideos" aria-label="to-all-videos">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text :class="['pa-0']">
        <div :class="['featured-video', 'video-wrapper']">
          <video-wrapper :play-videos-on-facebook="$config.playVideosOnFacebook" :video="video" />
<!--          <iframe title="facebook-embedded-player" seamless width="100%" height="100%" scrolling="no" frameborder="0" allowfullscreen="true" allow="false" :src="makePlayerUrl(false)" />-->
        </div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'FeaturedVideo',
  data () {
    return {
      video: null
    }
  },
  mixins: [
    methods
  ],
  props: {
    slug: {
      type: String,
      default: null
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const slug = this.slug
      if (!slug) {
        this.getRandomVideo()
      } else {
        const video = this.$root.videos.find(video => video.slug === this.slug)
        if (video) {
          this.video = video
        } else {
          this.getRandomVideo()
        }
      }
    },
    makePlayerUrl (autoPlay = true, showText = false) {
      const config = this.$config
      return `${config.facebookVideoPlayerRoot}/${config.bcArtistSlug}/videos/${this.video.id}/&show_text=${showText}&autoplay=${autoPlay}`
    }
  }
}
</script>
<style>
.homepage-video
{
  width: 100%;
  position: fixed;
  height: 100%;
  top: -8px;
  left: 0;
  background: url('/static/images/og-image.jpg');
  background-size: cover;
  background-position: center;
}

.homepage-video iframe
{
  border: 0;
  display: block;
}

.homepage-video > div
{
  position: fixed;
  backdrop-filter: blur(6px);
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, .75);
}

.homepage-video .large-headline
{
  text-transform: uppercase;
  letter-spacing: .25em !important;
  position: fixed;
  top: 50%;
  display: block;
  width: 100%;
  transform: translateY(-25%);
  font-size: 3.5vw;
}

.homepage-video .v-btn
{
  position: absolute;
  bottom: 64px;
  right: 26px;
}

.homepage-video .v-btn .v-icon
{
  font-size: 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/featured-video.vue